// extracted by mini-css-extract-plugin
export default {"wrapper":"ft-z","response":"gt-z","error":"ht-z","disabled":"it-z","buttons":"jt-z","feedbackQuestionSection":"kt-z","yesNoWrapper":"lt-z"};